import EditProviderBotContainer from './edit-strategy-bot-container';

export default EditProviderBotContainer;
